import { createI18n } from 'vue-i18n'
import en from './locales/en'
import fr from './locales/fr'

const saved = localStorage.getItem('kmz_locale')
const browserLang = navigator.language.startsWith('fr') ? 'fr' : 'en'
const locale = (saved === 'fr' || saved === 'en') ? saved : browserLang

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  messages: { en, fr },
})

export function setLocale(lang: 'en' | 'fr') {
  ;(i18n.global.locale as unknown as { value: string }).value = lang
  localStorage.setItem('kmz_locale', lang)
  document.documentElement.lang = lang
}
